<template>
  <div class="modal" v-bind:class="{ 'show-modal': modalShow, 'hidden': !modalShow }" id="product-cart">
    <div class="modal-dialog">
      <div class="modal-content">

        <!-- Modal Header -->
        <div class="modal-header">
          <h4 class="modal-title">{{ productCount }} {{ config.translate.add_to_cart_header }}</h4>
          <button type="button" class="close" @click="close">&times;</button>
        </div>

        <!-- Modal body -->
        <div class="modal-body">
          <div class="modal-cart-item" v-for="(p, pidx) in productItems" v-bind:key="pidx">

            <div class="cart-item-image" v-html="p.cart_product_image"></div>

            <div class="cart-item-data">

              <div class="row cart-item-name-row">
                <div class="col-12">{{ p.cart_product_name }}</div>
              </div>

              <div class="row">
                <div class="col-6 text-left">
                  {{ config.translate.cut_to_sizes }}
                </div>
                <div class="col-6 text-left">
                  {{ p.cart_product_size }}
                </div>
              </div>

              <div class="row">
                <div class="col-6 text-left">
                  {{ config.translate.quantity }}
                </div>
                <div class="col-6 text-left">
                  {{ p.cart_product_unit_size }}
                </div>
              </div>

              <div class="row">
                <div class="col-6 text-left">
                  {{ config.translate.piece }}
                </div>
                <div class="col-6 text-left">
                  {{ p.cart_product_quantity }}
                </div>
              </div>

              <div class="row">
                <div class="col-6 text-left">
                  {{ config.translate.unit_price }}
                </div>
                <div class="col-6 text-left">
                  {{ p.cart_product_unit_price }}
                </div>
              </div>

              <div class="row cart-total-row" v-if="pidx === Object.keys(productItems).length - 1">
                <div class="col-6 text-left">
                  <strong>{{ config.translate.total }}:</strong>
                </div>
                <div class="col-6 text-left">
                  <strong>{{ getFullPrice() }}</strong>
                </div>
              </div>

            </div>

          </div>

        </div>

        <!-- Modal footer -->
        <div class="modal-footer">
          <button type="button" class="btn btn-black-small text-red" @click="close">{{ config.translate.continue_shopping }}</button>
          <a href="/webshop/step/cart" class="btn btn-primary-small">{{ config.translate.checkout }}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Cart',
  props: ['config', 'cartItems'],
  data() {
    return {
      modalShow: false
    }
  },
  computed: {
    productItems() {
      return this.cartItems;
    },
    productCount(){
      return this.cartItems.length;
    },
    productTotalNetPrice(){
      let $cartItems = this.cartItems;
      let $totalNetPrice = 0;

      if($cartItems.length){
        for (let i in $cartItems){
          let $item = $cartItems[i];
          $totalNetPrice += parseInt($item.net_price_original);
        }
      }

      return $totalNetPrice;
    }
  },
  methods: {
    close: function (){
      this.modalShow = false;

      // Body
      document.body.classList.remove("modal-open");

      // Backdrop
      document.getElementById("modal-backdrop").remove();
    },
    open: function (){
      this.modalShow = true;

      // Body
      document.body.classList.add("modal-open");

      // Backdrop
      let div = document.createElement('div');
      div.id = 'modal-backdrop';
      div.classList.add('modal-backdrop');
      div.classList.add('fade');
      div.classList.add('show');
      document.body.appendChild(div);
    },
    getFullPrice: function(){
      var sum = 0;
      for(let i=0;i<this.productItems.length; i++){
        sum +=this.productItems[i].net_price_original;
      }
      return sum.toLocaleString() + ' ' + this.productItems[0].currency + ' + '+ this.config.translate.vat;
    }
  },
  watch: {
    cartItems: function($items) {
      if($items.length){
        this.open();
      }else{
        this.close();
      }
    }
  },
}
</script>